<template>
    <div>
        <v-dialog v-model="serviceTipsDialog" width="1200">
            <order-details-tips :tips="serviceTips" :loaded="true" show-close @close="serviceTipsDialog = false" />
        </v-dialog>
        <delete-service-dialog
            v-model="isShowDeleteServiceDialog"
            :process-id="service.processId"
            :service-name="service.serviceName"
            @update-order="$emit('modify-service', $event)"
        />
        <v-card
            variant="outlined"
            class="mb-2 service-card"
            :style="[
                {
                    opacity: service.visibleInReservation === false ? '0.6' : '1',
                },
            ]"
        >
            <v-alert
                color="grey-lighten-4"
                class="service-card__header text-black mb-0 pa-2 pa-sm-4"
                @click="isMinimized = !isMinimized"
            >
                <div class="d-flex align-start">
                    <div class="d-flex flex-column flex-grow-1">
                        <div class="d-md-flex align-md-center flex-wrap gc-4 gr-1">
                            <div
                                :class="{
                                    'full-width': isMobile,
                                }"
                                class="d-flex align-md-center"
                            >
                                <div class="service-card__header-title d-flex align-center flex-wrap gc-1">
                                    <div class="d-flex flex-row align-center gc-1">
                                        <slot v-if="!isMobile" name="checkbox" />
                                        <div
                                            v-if="service.serviceType === 'EXTRASERVICE'"
                                            class="d-flex align-center gc-1"
                                        >
                                            <v-icon size="x-small">
                                                {{ 'mdi-cloud-off-outline' }}
                                            </v-icon>
                                            <v-icon size="x-small">
                                                {{ extraServiceTypeIcon }}
                                            </v-icon>
                                        </div>
                                        <v-icon v-else size="x-small">
                                            {{ serviceTypeIcon }}
                                        </v-icon>
                                        <span
                                            class="service-name text-subtitle-1 font-weight-medium"
                                            v-text="serviceName"
                                        />
                                    </div>
                                    <hotel-stars
                                        v-if="service.serviceDetails[0].category || service.serviceDetails[0].ratings"
                                        :hotel="service.serviceDetails[0]"
                                        class="mb-1"
                                    />
                                    <div
                                        v-if="isMobile"
                                        style="flex: 1 1 100%"
                                        class="text-subtitle-1 font-weight-regular text-medium-emphasis"
                                    >
                                        <p v-if="isTO1 && supplierName" v-text="supplierName" />
                                        <template v-if="dateString">
                                            <p class="service-card__header-bottom-date" v-text="dateString" />
                                        </template>
                                        <template v-if="travelersString">
                                            <p class="travelers" v-text="travelersString" />
                                        </template>
                                    </div>
                                </div>
                                <div v-if="isMobile" class="d-flex flex-shrink-0 ml-auto">
                                    <v-icon
                                        size="small"
                                        color="primary"
                                        class="service-card__header-arrow"
                                        :class="['pending mx-2 align-self-end-sm', {'chevron-down': isMinimized}]"
                                    >
                                        {{ isMinimized ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                                    </v-icon>
                                </div>
                            </div>
                            <div class="service-card__header-icons mt-2 mt-md-0 d-flex align-center gc-3">
                                <v-chip
                                    v-if="serviceType && serviceType !== 'UNKNOWN'"
                                    label
                                    size="small"
                                    class="cursor-default"
                                >
                                    {{ $t(`filters_${service.serviceType.toLowerCase()}Type.${serviceType}`) }}
                                </v-chip>
                                <v-icon
                                    icon="mdi-information-outline"
                                    size="x-small"
                                    density="comfortable"
                                    @click.stop="serviceInfo"
                                />
                                <slot v-if="!isMobile" name="icons" />
                                <span v-if="showHeaderIconText" class="text-primary text-decoration-underline">
                                    {{ $t('service_card_info') }}
                                </span>
                                <service-tips-icon
                                    v-if="serviceTips && serviceTips.length && !isReadOnly"
                                    density="comfortable"
                                    @click.native.stop="serviceTipsDialog = true"
                                />
                                <v-btn
                                    v-if="!isReadOnly"
                                    v-tooltip:bottom="$t('internal_note', 2)"
                                    :loading="isInfoLoading"
                                    color="black"
                                    icon="mdi-note-plus-outline"
                                    variant="text"
                                    size="small"
                                    density="comfortable"
                                    @click.stop="showServiceNotes"
                                />
                                <span v-if="showHeaderIconText" class="text-primary text-decoration-underline">
                                    {{ $t('service_card_notes') }}
                                </span>
                                <v-tooltip v-if="isAddOn" location="bottom">
                                    <template v-slot:activator="{props}">
                                        <v-btn
                                            color="primary"
                                            icon="mdi-puzzle"
                                            variant="text"
                                            size="small"
                                            v-bind="props"
                                            density="comfortable"
                                            @click.native.stop
                                        />
                                    </template>
                                    {{
                                        $t('add_on_to_service', {
                                            service: addOnBaseService
                                                ? addOnBaseService.serviceName
                                                : $t('error_message.not_found').toLocaleLowerCase(),
                                        })
                                    }}
                                </v-tooltip>
                                <v-btn
                                    v-if="isShowFeedbackBtn && !isReadOnly"
                                    elevation="0"
                                    variant="flat"
                                    size="small"
                                    :title="serviceReview ? $t('feedback_is_added') : $t('feedback')"
                                    :loading="serviceReviewLoading"
                                    :color="
                                        serviceReview && serviceReview.canRecommend === true
                                            ? 'success-lighten-3'
                                            : serviceReview && serviceReview.canRecommend === false
                                              ? 'error-lighten-3'
                                              : null
                                    "
                                    density="comfortable"
                                    @click.stop="showServiceReviewForm"
                                >
                                    <v-icon size="small" color="black" class="info-icon cursor-pointer me-1">
                                        mdi-thumb-up-outline
                                    </v-icon>
                                    <v-icon size="small" color="black" class="info-icon cursor-pointer">
                                        mdi-thumb-down-outline
                                    </v-icon>
                                </v-btn>
                            </div>
                            <v-row
                                v-if="!isReadOnly && $conf.public.account.tripVariants"
                                density="compact"
                                no-gutters
                                class="my-4 my-sm-0"
                            >
                                <v-col cols="12">
                                    <div class="d-flex flex-wrap align-center ga-2">
                                        <div
                                            class="d-flex align-center gc-1 cursor-pointer font-weight-medium"
                                            @click.stop="isAddVariantMode = true"
                                        >
                                            <v-icon start size="x-small" class="ma-0">mdi-plus-circle-outline</v-icon>
                                            <span class="text-caption">{{ $t('add_variants') }}</span>
                                        </div>
                                        <v-chip
                                            v-for="variant in serviceVariants"
                                            :key="variant"
                                            size="small"
                                            :color="getBackgroundColor(variant)"
                                            append-icon="mdi-close"
                                            @click.stop="removeVariant(variant)"
                                        >
                                            {{ variant }}
                                        </v-chip>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <template v-if="isAddVariantMode">
                                        <v-menu
                                            ref="menu"
                                            v-model="isAddVariantMode"
                                            :close-on-content-click="false"
                                            :location="'bottom'"
                                        >
                                            <template v-slot:activator="{props}">
                                                <div class="full-width" v-bind="props" />
                                            </template>
                                            <v-sheet width="400px" class="d-flex align-center" @click.stop>
                                                <service-variants-field
                                                    v-model="serviceVariantsData"
                                                    dense
                                                    hide-details
                                                    :variants-available="variantsAvailable"
                                                />
                                                <v-btn
                                                    class="ms-4 me-1"
                                                    size="x-small"
                                                    icon="mdi-check-circle-outline"
                                                    :color="'success'"
                                                    @click.stop="saveVariants"
                                                />
                                                <v-btn
                                                    class="ms-1 me-4"
                                                    size="x-small"
                                                    icon="mdi-close"
                                                    @click.stop="isAddVariantMode = false"
                                                />
                                            </v-sheet>
                                        </v-menu>
                                    </template>
                                </v-col>
                            </v-row>
                            <div class="d-flex align-center justify-space-between ml-md-auto ga-2">
                                <slot v-if="isMobile && !isReadOnly" name="checkbox" />
                                <slot v-if="isMobile" name="icons" />
                                <div class="ml-auto d-flex flex-row-reverse flex-wrap gc-3 gr-2">
                                    <div class="mb-md-0 d-flex flex-column justify-md-center flex-shrink-0">
                                        <div
                                            class="d-flex flex-row align-center gc-1"
                                            :class="[
                                                {'mb-1': !!lastTicketingDate},
                                                {'ml-auto': !$breakpoint.smAndDown},
                                            ]"
                                        >
                                            <v-btn
                                                v-if="service.status.toUpperCase() === 'QUOTE' && isTO1"
                                                v-tooltip:bottom="$t('delete_service')"
                                                icon="mdi-trash-can-outline"
                                                variant="text"
                                                size="small"
                                                density="comfortable"
                                                @click.stop="deleteService"
                                            />
                                            <v-icon
                                                v-if="service.status.toUpperCase() === 'CONFIRMED'"
                                                :class="statusColor"
                                                class="confirmed"
                                                size="x-small"
                                            >
                                                mdi-checkbox-marked-circle
                                            </v-icon>
                                            <v-icon v-else class="status-ic" :class="statusColor" size="x-small">
                                                mdi-checkbox-blank-circle
                                            </v-icon>
                                            <span
                                                class="text-caption status-text"
                                                v-text="$t(`bookingStatus.${status}`)"
                                            />
                                            <v-icon
                                                v-if="!isMobile"
                                                color="primary"
                                                class="service-card__header-arrow"
                                                :class="[
                                                    'pending mx-2 align-self-end-sm',
                                                    {'chevron-down': isMinimized},
                                                ]"
                                            >
                                                {{ isMinimized ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                                            </v-icon>
                                        </div>
                                        <small
                                            v-if="lastTicketingDate"
                                            class="d-block text-caption text-medium-emphasis"
                                        >
                                            {{ $t('flights.last_ticketing_date') }}:
                                            <span class="font-weight-medium">
                                                {{ $filters.dateTimeFormat(lastTicketingDate) }}
                                            </span>
                                        </small>
                                    </div>
                                    <div class="d-flex flex-column align-end">
                                        <v-chip
                                            v-if="isShowBookingMethod && service.bookingMethod"
                                            :color="bookingMethodColor"
                                            label
                                            size="small"
                                        >
                                            <span>
                                                <span v-if="service.bookingMethod !== 'MANUALLY_AMENDED'">
                                                    {{ `${$t('booked_from_label')} ` }}
                                                </span>
                                                <span> {{ $t(`booking_methods.${service.bookingMethod}`) }} </span>
                                            </span>
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="!isMobile"
                            class="d-flex flex-column flex-md-row align-md-center gc-2 text-subtitle-1 font-weight-regular flex-wrap pt-2 text-medium-emphasis"
                        >
                            <p v-if="isTO1 && supplierName" v-text="supplierName" />
                            <template v-if="dateString">
                                <span>|</span>
                                <p class="service-card__header-bottom-date" v-text="dateString" />
                            </template>
                            <template v-if="travelersString">
                                <span>|</span>
                                <p class="travelers" v-text="travelersString" />
                            </template>
                        </div>
                    </div>
                </div>
            </v-alert>
            <v-expand-transition>
                <div v-show="!isMinimized">
                    <v-card-text class="pa-2 pa-sm-4">
                        <slot name="orderInfo" />
                        <slot name="serviceInfo" />
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Setup, Vue, Watch, Inject} from 'vue-facing-decorator'
    import HotelStars from '~src/components/hotels/snippets/hotelStars.src'
    import {getServiceTypeIcon} from '~src/utils/helpers'
    import OrderDetailsTips from '@/components/account/OrderDetailsTips.vue'
    import ServiceTipsIcon from '~src/components/account/orderServices/ServiceTipsIcon.vue'
    import {
        EventBus,
        SERVICE_FEEDBACK_SAVED,
        SHOW_SERVICE_FEEDBACK_MODAL,
        SHOW_SERVICE_NOTES_MODAL,
    } from '@/utils/event-bus'
    import DeleteServiceDialog from '@/components/account/orderServices/DeleteServiceDialog.vue'
    import ServiceVariantsField from '~src/components/account/snippets/ServiceVariantsField.vue'

    @Component({
        components: {DeleteServiceDialog, ServiceTipsIcon, OrderDetailsTips, HotelStars, ServiceVariantsField},
    })
    export class ServiceCard extends Vue {
        @Prop() icon
        @Prop() service
        @Prop() isFirst
        @Prop() extraServiceName
        @Prop() serviceTips
        @Prop({required: true}) order
        @Prop() isInfoLoading
        @Prop() variantsAvailable
        @Inject({default: false}) isReadOnly
        @Setup(() => useProductVariants().getProductVariantById) getProductVariantById: Function

        isShowDeleteServiceDialog = false
        isMinimized = true
        serviceTipsDialog = false

        serviceReview = null
        serviceReviewLoading = false

        isAddVariantMode = false
        serviceVariantsData = []

        @Watch('isMinimized')
        onMinimizedChange() {
            this.minimizedChange(this.isMinimized)
        }

        @Emit()
        minimizedChange(isMinimized) {
            return isMinimized
        }

        async created() {
            if (this.isFirst === true) {
                this.isMinimized = false
            }
            this.minimizedChange(this.isMinimized)
            if (this.isShowFeedbackBtn) {
                await this.getServiceFeedbacks()
            }

            this.serviceVariantsData = [...(this.service.serviceVariants || [])]
        }

        mounted() {
            if (this.isShowFeedbackBtn) {
                EventBus.$on(SERVICE_FEEDBACK_SAVED, this.getServiceFeedbacks)
            }
        }

        beforeUnmount() {
            if (this.isShowFeedbackBtn) {
                EventBus.$off(SERVICE_FEEDBACK_SAVED, this.getServiceFeedbacks)
            }
        }

        async getServiceFeedbacks() {
            try {
                this.serviceReviewLoading = true
                this.serviceReview = (
                    await this.$api.serviceReviews.get({
                        processId: this.service.processId,
                    })
                ).reviews?.[0]
            } finally {
                this.serviceReviewLoading = false
            }
        }

        serviceInfo() {
            this.$emit('show-info')
        }

        showServiceNotes() {
            EventBus.$emit(SHOW_SERVICE_NOTES_MODAL, this.service)
        }

        showServiceReviewForm() {
            EventBus.$emit(SHOW_SERVICE_FEEDBACK_MODAL, this.service, this.serviceReview)
        }

        deleteService() {
            this.isShowDeleteServiceDialog = true
        }

        async saveVariants() {
            try {
                await this.$api.orders.put(this.order.orderId, {
                    serviceVariants: {
                        [this.service.processId]: [...this.serviceVariantsData],
                    },
                })

                this.service.serviceVariants.splice(0, this.service.serviceVariants.length, ...this.serviceVariantsData)
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.isAddVariantMode = false
            }
        }

        async removeVariant(variant) {
            this.serviceVariantsData = this.serviceVariantsData.filter(serviceVar => serviceVar !== variant)
            await this.saveVariants()
        }

        getBackgroundColor(stringInput) {
            let hash = 0
            for (let i = 0; i < stringInput.length; i++) {
                hash = stringInput.charCodeAt(i) + ((hash << 5) - hash)
                hash = hash & hash
            }
            let h = hash % 360
            let s = 70 + (hash % 25)
            let l = 40 + (hash % 20)
            // Exclude light green, yellow and light shades
            while ((h >= 60 && h <= 120 && l > 50) || (h >= 40 && h <= 80) || l > 70) {
                h = (h + 180) % 360
                l = 55 - (hash % 20)
            }
            return `hsl(${h}, ${s}%, ${l}%)`
        }

        get isShowBookingMethod() {
            return this.isTO1 && this.isOwnProduct
        }

        get bookingMethodColor() {
            switch (this.service.bookingMethod) {
                case 'MANUALLY_AMENDED':
                    return 'primary'
                case 'ALLOTMENT':
                    return 'success'
                case 'ON_REQUEST':
                    return 'warning'
                default:
                    return 'error'
            }
        }

        get isOwnProduct() {
            return runtimeStore.ownProduct(this.service.supplierCode)
        }

        get serviceType() {
            return this.service.serviceDetails[0].type || this.service.serviceDetails[0].transferType
        }

        get statusColor() {
            return runtimeStore.orderServiceStatusColor(this.status)
        }

        get status() {
            return runtimeStore.orderServiceStatus(this.service.status)
        }

        get lastTicketingDate() {
            return this.service.serviceDetails[0].lastTicketingDate
        }

        get serviceTypeIcon() {
            return this.getProductVariantById(this.service.productVariantId)?.icon || getServiceTypeIcon(this.service)
        }

        get extraServiceTypeIcon() {
            return getServiceTypeIcon({serviceType: this.service.serviceDetails[0]?.extraServiceProductType})
        }

        get serviceName() {
            return (
                this.service.serviceDetails[0].flightName ||
                this.service.serviceDetails[0].transferName ||
                this.service.serviceName
            )
        }

        get supplierName() {
            return this.service.supplierCompanyName
        }

        get dateString() {
            const formattedDateStart = this.$filters.dateFormat(this.service.startDateTime)
            const formattedDateEnd = this.$filters.dateFormat(this.service.endDateTime)

            return (
                formattedDateStart + (formattedDateEnd === formattedDateStart ? '' : `\u00A0-\u00A0${formattedDateEnd}`)
            )
        }

        get travelersString() {
            if (this.service.travelers.length > 2) {
                const tourLead =
                    this.service.travelers.find(t => {
                        t.isTourLead
                    }) || this.service.travelers[0]
                return `${tourLead.name[0].firstName} ${tourLead.name[0].lastName || ''} + ${
                    this.service.travelers.length - 1
                }`
            } else {
                return this.service.travelers
                    .filter(t => t.name[0].firstName || t.name[0].lastName)
                    .map(e => {
                        return `${e.name[0].firstName || ''} ${e.name[0].lastName || ''}`
                    })
                    .join(', ')
            }
        }

        get isTO1() {
            return authStore.isTO1
        }

        get isB2C() {
            return authStore.isB2C
        }

        get isAddOn() {
            return (
                !!this.service.addOnServiceId &&
                (this.addOnBaseService?.serviceType !== 'ACCOMMODATION' ||
                    this.service.serviceType !== this.addOnBaseService?.serviceType)
            )
        }

        get addOnBaseService() {
            return this.order.services.find(service => service.serviceId === this.service.addOnServiceId)
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }

        get isShowFeedbackBtn() {
            return (
                this.service.serviceType === 'ACCOMMODATION' &&
                this.service.status === 'Confirmed' &&
                this.$dateFns.isBefore(new Date(this.service.endDateTime), new Date()) &&
                this.isB2C &&
                this.$conf.public.account.reviewsAndFeedback
            )
        }

        get serviceVariants() {
            return [...(this.service.serviceVariants || [])]
        }

        get showHeaderIconText() {
            return false
        }
    }

    export default ServiceCard
</script>
